<script></script>

<h1>Infos</h1>
<div class="Wrapper">
    <div class="Infografik">
        <div class="Infofenster">
            <h2>Contact me:</h2>
            💌 I have an e-mail address for business inquiries. You can reach me
            via<br /><span class="email"
                >tiia<!-- abc@def -->like<!-- @abc.com -->spink<!-- abc@def -->@<!-- abc@def -->gmail<!-- abc@def -->.com</span
            ><br />
            <br />
            💻 If you want to reach out to me, you can also use Discord:
            <span class="email">TiiaAurora#1337 </span>
            <br />
            <br />
            🦄 My Discord-Server is available at: <br />
            <a href="http://discord.gg/TiiaAurora"> TiiaAuroras Discord</a>
        </div>
        <div class="Infofenster">
            <h2>Find me:</h2>
            If you want to connect with me via Social Media, feel free to do this
            via these channels:
            <br /><br />
            <list>
                <li>
                    <a href="https://twitter.com/TiiaAurora" target="_blank"
                        >Twitter</a
                    >
                </li>
                <li>
                    <a href="https://github.com/TiiaAurora" target="_blank"
                        >GitHub</a
                    >
                </li>
                <li>
                    <a
                        href="https://www.instagram.com/pencilnoir/"
                        target="_blank">Instagram</a
                    >
                </li>
                <li>
                    <a
                        href="https://www.tiktok.com/@tinytiia?lang=en"
                        target="_blank">TikTok</a
                    >
                </li>
            </list>
        </div>
        <div class="Infofenster">
            <h2>Quick Infos About Me:</h2>
            • Neurodiverse<br />
            • 12k hours in ARK <br />
            • Genetics-Nerd <br />
            • Data-Nerd<br />
            • Optimist <br />
            • Ambitious <br />
            • Philomath / Polymath
        </div>
    </div>
</div>

<style>
    div.Infofenster {
        margin: 20px;
        font-family: "Raleway", sans-serif;
        font-size: 15px;
    }
    div.Wrapper {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    div.Infografik {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }
    h1 {
        font-family: "IM Fell English SC", serif;
        color: rgb(233, 107, 24);
        text-shadow: 3px 3px 8px black;
    }

    span.email {
        font-weight: bolder;
    }

    a {
        color: rgb(233, 107, 24);
    }

    h2 {
        font-family: "IM Fell English SC", serif;
        font-size: 18px;
    }
    list li {
        list-style: none;
    }

    @media (orientation: portrait) {
        div.Infografik {
            grid-template-columns: 1fr;
        }
    }
</style>
